import { useState, useEffect } from "react";
import { useLazyQuery } from "react-apollo";

import { calcTimeZone } from "../utils";

import { ALL_ORDERS_QUERY } from "../graphql/Orders/Orders.graphql";

export default function useOrdersByTripKey(tripKeys = []) {
  const [result, setResult] = useState([]);

  const [
    getOrders,
    { data: OrdersData, loading: OrdersDataLoading }
  ] = useLazyQuery(ALL_ORDERS_QUERY, { fetchPolicy: "cache-and-network" });

  useEffect(() => {
    if (tripKeys.length) {
      getOrders({
        variables: {
          where: {
            Void_not: true,
            Cancel_not: true,
            OR: tripKeys
              .filter(x => !!x)
              .map(tripKey => ({ TripKey_startsWith: tripKey }))
          }
        }
      });
    }
  }, [getOrders, tripKeys]);

  useEffect(() => {
    const orders = OrdersData?.Orders;

    if (orders) {
      setResult(
        orders.map(order => {
          // TODO - Sometimes you just need to get something released....
          const timeZone = "EST";
          return {
            ...order,
            PickupDate:
              order.PickupDate && calcTimeZone(order.PickupDate, timeZone),
            PickupDateTime:
              order.PickupDateTime &&
              calcTimeZone(order.PickupDateTime, timeZone),
            ScheduledDeliveryTime:
              order.ScheduledDeliveryTime &&
              calcTimeZone(order.ScheduledDeliveryTime, timeZone)
          };
        })
      );
    }
  }, [OrdersData]);

  return {
    orders: result,
    loading: OrdersDataLoading
  };
}
